import { SATError, SATErrorType, SATResult } from "@sadtx/sat-error";

/**
 * Mapper 함수를 안전하게 실행하여 SATResult로 반환하는 헬퍼 메서드
 */
export function safeMapToEntity<T, U>(
  value: T | undefined | null,
  mapper: (value: T) => U,
  errorContext: string
): SATResult<U, SATError> {
  try {
    if (value == null || value == undefined) {
      return SATResult.failure(
        new SATError(
          SATErrorType.FailConvertDtoToEntityError,
          `[safeMapToEntity] :: ${errorContext} :: value is null or undefined`
        )
      );
    }

    const result = mapper(value);
    // console.log(`[safeMapToEntity] :: ${errorContext} :: Mapper 성공`, result);
    return SATResult.success(result);
  } catch (error) {
    console.error("[safeMapToEntity] :: Mapper 오류", { errorContext, error });
    return SATResult.failure(
      new SATError(
        SATErrorType.FailConvertDtoToEntityError,
        error instanceof Error ? error.message : String(error)
      )
    );
  }
}
